import { logger } from '../lib/logging'
import { reportToSentry } from './sentry'
import { UNAUTHORIZED } from 'http-status-codes'

export const errorHandler = app => context => {
  const error = context.error

  if (!error) {
    return context
  }

  // Built-in authentication errors from feathersjs have the UNAUTHORIZED code.
  // Legacy code also has custom authentication errors that have the message "You are not authenticated."
  // In both cases we no longer have a valid session so we should log the user out.
  if (error.message === 'You are not authenticated.' || error.code === UNAUTHORIZED) {
    // Annoyingly, feathersjs also throws these authentication error when you try to do something
    // when authentication, e.g. complaining that it can't find a valid strategy when you try to logout.
    // So we only want to logout if the path of the hook is not `authentication` otherwise we end up
    // in a loop.
    if (context.path !== 'authentication') {
      logger.debug('User is not properly authenticated, logging out.', { hook: context })
      this.authentication.logout()
    }

    return context
  }

  // All errors we log will be reported to Sentry, but we prefer to report
  // errors directly here since we have more context. We mark the errors
  // so they will not be reported double.
  if (error.code && error.code >= 500) {
    try {
      reportToSentry(error, { context, app })
    } catch (error) {
      console.error(error)
    }
    error.isReportedToSentry = true
  }

  logger.error(error)

  return context
}
